var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{staticClass:"modal-point",attrs:{"visible":_vm.visible,"size":_vm.size},on:{"cancel":_vm.handleClose}},[_c('UseBenepoint',{attrs:{"visible":_vm.visible,"useCafe":_vm.useCafe,"keyboard":false},on:{"ok":_vm.handleOk,"close":_vm.handleClose}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }